import { useDispatch, useSelector } from "react-redux";
import AlertMahuti from "../../components/mahuti-alerts/AlertMahuti";
import { MahutiStepper } from "../../components/mahuti-stepper/MahutiStepper";
import { currectStepComponent, mySteps, myStepsMOBILE } from '../../utils/stepperUtils'
import OrderSummary from '../../components/order-summary/OrderSummary'
import './LandingColumnDate.css'
import StepperBtns from "../../components/stepper-btns/StepperBtns";
import { HeaderName } from "../../utils/routeUtils";
import BasketComp from "../../components/basket-comp/BasketComp";
import { isMobile } from "react-device-detect";
import { FLOW_TYPE, getCoverPhoto } from "../../utils/GlobalParams";
import { useEffect } from "react";
import { setCurrentStep, setFlowType, setSteps } from "../../store/MahutiReducer";
import Footer from "../../components/footer/Footer";
import MahutiHeader from "../../components/mahuti-header/MahutiHeader";
import { checkCartItems } from "../../utils/orderUtils";
import { useLocation, useNavigate } from "react-router-dom";



export default function LandingColumnDate(props) {

    const store = useSelector(state => state.reducer);
    const dispatch = useDispatch();
    const date_checkout = store.flowType === 'DATE_FLOW' && store.currentStep === 3;
    const underAgeNum = store.visitors?.underAge || 0;
    const adultNum = store.visitors?.adults || 0;
    const sumPrice = (store.selectedActivity?.price?.underAge * underAgeNum || '-') + (store.selectedActivity?.price?.adults * adultNum || '-')
    let summaryCompDisplay = () => store.currentStep === mySteps.length - 1 ? <BasketComp /> : <OrderSummary orderPayment={sumPrice} />
    const navigate = useNavigate();
    const location = useLocation();
    let steps = isMobile ? myStepsMOBILE : mySteps
    
    useEffect(() => {
        dispatch(setFlowType(FLOW_TYPE.DATE_FLOW))
        store.steps?.length !== 4 && dispatch(setSteps(steps))
        checkCartItems(store, dispatch, navigate, location)
        checkSteps()
    }, [])

    useEffect(() => {
        checkSteps()
        summaryCompDisplay = () => store.currentStep === mySteps.length - 1 ? <BasketComp /> : <OrderSummary orderPayment={sumPrice} />;
    }, [store.currentStep])

    const checkSteps = () => {
        if(store.currentStep === 3 && store.createMode && !store.refresh){
            if( !store.selectedActivity || 
                !store.activityDate || 
                !store.selectedActivity.visitors ||
                !store.selectedActivity.timing){
                    dispatch(setCurrentStep(store.currentStep - 1))
                    console.log('step 3 test is falsy!!')
            }
        }else if(store.currentStep === 2){
            if(!store.selectedActivity || 
                !store.activityDate){
                    dispatch(setCurrentStep(store.currentStep - 1))
                    console.log('step 2 test is falsy!!')
            }
        }else if(store.currentStep === 1){
            if(!store.activityDate){
                dispatch(setCurrentStep(store.currentStep - 1))
                console.log('step 1 test is falsy!!')
            }
        }else{
            //console.log('step check is ok')
        }
    }

    return <>
        <div className="landingColumnDate">
            <header className="main-header">
                <MahutiHeader contrastTogglerRef={props.contrastTogglerRef} landingPageParams={props.landingPageParams} />
            </header>
            {isMobile ? <div>
                <div className="align-items-center justify-content-center cover-img d-flex" style={getCoverPhoto(props?.landingPageParams?.Image__c)}>
                    <h1 className='header-cover-title almoni_tzar_normal'>
                        <span>{HeaderName()}</span>
                    </h1>
                </div>
                {false && <AlertMahuti role='danger' desription='Alerttt' />}
                <div className="container bg-body gx-0">
                    <div className="mahutiStepperWrapper">
                        <MahutiStepper steps={myStepsMOBILE} />
                    </div>

                    <div>
                        <div className="pt-0 pt-lg-2">
                            <div className="d-flex flex-column">
                                {store.columnMessage?.info && (date_checkout) && !store.columnMessage?.alert &&
                                <div className="alert alert-success alef rounded-0 boot_msg mb-0"><span className="">{store.columnMessage?.info}</span></div>}
                                {store.columnMessage?.alert && (date_checkout) &&
                                <div className="alert_warning_back boot_msg"><span className="alert_warning">{store.columnMessage.alert}</span></div>}
                                <div id='contains-stepper' className="landingPageStep">
                                    {currectStepComponent(store.currentStep)}
                                </div>
                            </div>
                        </div>

                        <div id='orderSummaryWrapper' className="pt-lg-2">
                            {summaryCompDisplay()}
                        </div>


                        {store.currentStep < mySteps.length - 1 && <div className="stepper d-flex justify-content-end">
                            <StepperBtns steps={myStepsMOBILE} />
                        </div>}

                    </div>
                </div>
            </div> :
            <div className="cover-img" style={getCoverPhoto(props?.landingPageParams?.Image__c)}>
                <h1 className='header-cover-title'>
                    {props.landingPageParams?.Hero_Title__c}
                </h1>
                <span className="header-cover-subTitle">{props.landingPageParams?.Date_Flow_Subtitle__c}</span>
                <div className="container mt-5" id='sellingflow'>
                    <div id="sellingflow_view"></div>
                    <div className="mahutiStepperWrapper d-flex justify-content-center p-2">
                        <MahutiStepper steps={mySteps} />
                    </div>
                    <div className="row gx-0 justify-content-center">
                        {store.columnMessage?.info && (date_checkout) && !store.columnMessage?.alert &&
                        <div className="alert alert-success alef rounded-0 boot_msg"><span className="">{store.columnMessage?.info}</span></div>}
                        {store.columnMessage?.alert && (date_checkout) &&
                        <div className="alert_warning_back boot_msg" role="alert"><span className="alert_warning">{store.columnMessage.alert}</span></div>}

                        <div className="col-lg-7 col-12">
                            <div id='contains-stepper' className="landingPageStep">
                                {currectStepComponent(store.currentStep)}
                            </div>
                        </div>
                        <div id='orderSummaryWrapper' className="col-12 col-lg-5">
                            <div className="order_summery_box pe-lg-5 ps-lg-5 pb-lg-5">
                                {summaryCompDisplay()}
                            </div>
                        </div>
                        <div className="col-lg-7 col-12">
                            {store.currentStep < mySteps.length - 1 && <div className="stepper col-xs-10 d-flex justify-content-end">
                                <StepperBtns steps={mySteps} />
                            </div>}
                        </div>
                        <div className="col-12 col-lg-5"></div>
                    </div>
                </div>
            </div>} 
        </div>
        <Footer landingPageParams={props.landingPageParams} />
    </>
}